import React from 'react'
import { FBPage } from 'components/FbUI/Page/FBPage'

export function PageMock(): React.ReactElement {
  return (
    <div
      className="w-full border border-line rounded overflow-hidden"
      style={{ height: 180 }}
    >
      <FBPage
        headerChildren={
          <span className="text-sm font-semibold text-fg">Page Header</span>
        }
        footerChildren={
          <span className="text-xs text-fg-secondary">Page Footer</span>
        }
      >
        <p className="text-sm text-fg-secondary p-4">
          FBPage wraps content with a sticky header and optional footer.
        </p>
      </FBPage>
    </div>
  )
}
